export const campaignFormInputs = {
  name: '',
};
